import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#060D1A] flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-10 text-center">
        <h1 className="font-display text-2xl font-bold text-white">Checkout cancelled</h1>
        <p className="mt-3 text-slate-400">
          No charge was made. You can subscribe anytime from your dashboard.
        </p>
        <Link
          to="/dashboard"
          data-testid="payment-cancel-dashboard-link"
          className="mt-8 inline-flex items-center gap-2 justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-[#060D1A] transition-colors duration-300 hover:bg-slate-300"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
